window.setCookie = function setCookie(name,value,days,path)
{
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 86400000));
		expires = "" + date.toGMTString();
	}

	if (path) {
		document.cookie = name + "=" + value + "; expires=" + expires + "; path=" + path;
	} else {
		document.cookie = name + "=" + value + "; expires=" + expires + "; path=/";
		document.cookie = name + "=" + value + "; expires=" + expires + "; path=" + location.pathname;
	}
}

window.getCookieVal = function getCookieVal(offset)
{
	var endstr = document.cookie.indexOf(";", offset);
	if (endstr == -1) {
		endstr = document.cookie.length;
	}
	return unescape(document.cookie.substring(offset, endstr));
}

window.getCookie = function getCookie(name)
{
	var arg = name + "=";
	var alen = arg.length;
	var clen = document.cookie.length;
	var i = 0;
	while (i < clen) {
		var j = i + alen;
		if (document.cookie.substring(i, j) == arg) {
			return getCookieVal(j);
		}

		i = document.cookie.indexOf(" ", i) + 1;
		if (i === 0) {
			break;
		}
	}
	return null;
}

window.deleteCookie = function deleteCookie(name)
{
	setCookie(name,"",-1);
}
